import axios from "axios";
if (process && process.env.NODE_ENV === "test") {
  var url_to_auth = "http://id.gataene.local";
  window.lexConfig = {
    url_to_app: "http://api.gataene.local/v1",
    url_to_auth: url_to_auth,
    auth_client_id: 2,
    auth_access_token_uri: url_to_auth + "/oauth/token",
    auth_authorization_uri: url_to_auth + "/oauth/authorize",
    auth_redirect_uri: "http://app.gataene.local/login",
    auth_scopes: "*"
  };
}
axios.defaults.withCredentials = true;
axios.defaults.adapter = "fetch";

const apiUrl = window.lexConfig.url_to_app;
const authUrl = window.lexConfig.url_to_auth;

const errorHandler = error => {
  if (error.response.status === 401) {
    localStorage.userToken = "";
    window.location.reload();
  }
  return Promise.reject(error);
};

const actions = {
  apiUrl,
  authUrl,
  get(url, params = {}) {
    return axios
      .get(this.apiUrl + url, params)
      .then(response => Promise.resolve(response))
      .catch(errorHandler);
  },
  post(url, params = {}, options = {}) {
    return axios
      .post(this.apiUrl + url, params, options)
      .then(response => Promise.resolve(response))
      .catch(errorHandler);
  },
  put(url, params = {}, options = {}) {
    return axios
      .put(this.apiUrl + url, params, options)
      .then(response => Promise.resolve(response))
      .catch(errorHandler);
  },
  patch(url, params = {}) {
    return axios
      .patch(this.apiUrl + url, params)
      .then(response => Promise.resolve(response))
      .catch(errorHandler);
  },
  delete(url, params = {}) {
    return axios
      .delete(this.apiUrl + url, { data: params })
      .then(response => Promise.resolve(response))
      .catch(errorHandler);
  },
  helpers: {
    formFilters(filters) {
      if (!filters) {
        return "";
      }
      let urlQuery = "";
      if (Object.keys(filters).length) {
        for (let [key, value] of Object.entries(filters)) {
          if (value && value !== "") {
            if (typeof value === "object") {
              //Delete all empty in value
              for (var propName in value) {
                if (value.hasOwnProperty(propName) && !value[propName]) {
                  delete value[propName];
                }
              }
              if (!Object.keys(value).length) {
                continue;
              }
              //if still have som one just do or
              value = (value.from || "") + ";" + (value.to || "");
            }
            urlQuery += `${key}:${value}/`;
          }
        }
        urlQuery = urlQuery.slice(0, -1);
      }
      return urlQuery;
    },
    clearResource(params) {
      delete params.isNewItem;
      return params;
    }
  }
};

export default actions;
